import { SlackChannels } from './SlackChannels'

/**
 * Mapping of SlackChannels to Google Chat webhook URLs.
 *
 * @deprecated Google Chat notifications are disabled — use Slack via notify() instead.
 * Webhook URLs must not be committed to the repo.
 *
 * Previously mapped channels (for re-enablement reference):
 * - OPS_ERRORS, OPS_MOBILE_AUTH_ERRORS, OPS_PAYMENT, OPS_SENDGRID, OPS_POSTMARK
 * - OPS_NEWCUSTOMER, OPS_SWISH, OPS_COMMUNICATION_SENDOUT, OPS_SMS
 * - OPS_PAYMENT_REMINDER, OPS_FORTNOX, OPS_SEB_TRANSACTIONS
 *
 * To re-enable: create fresh webhooks in Google Chat, add URLs here (or prefer
 * env/secrets), set enableGoogleChat: true in the relevant workspace Config.ts.
 */
export const GOOGLE_CHAT_WEBHOOKS: Partial<Record<SlackChannels, string>> = {}
